const Items = [
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-1',
        theme: 'Cristo el Centro',
        ref: '2 Corintios 5:17',
        text: {
            lbla: 'De modo que si alguno está en Cristo, nueva criatura es; las cosas viejas pasaron; he aquí, son hechas nuevas.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-2',
        theme: 'Cristo el Centro',
        ref: 'Gálatas 2:20',
        text: {
            lbla: 'Con Cristo he sido crucificado, y ya no soy yo el que vive, sino que Cristo vive en mí; y la vida que ahora vivo en la carne, la vivo por fe en el Hijo de Dios, el cual me amó y se entregó a sí mismo por mí.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-3',
        theme: 'Obediencia a Cristo',
        ref: 'Romanos 12:1',
        text: {
            lbla: 'Por consiguiente, hermanos, os ruego por las misericordias de Dios que presentéis vuestros cuerpos como sacrificio vivo y santo, aceptable a Dios, que es vuestro culto racional.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-4',
        theme: 'Obediencia a Cristo',
        ref: 'Juan 14:21',
        text: {
            lbla: 'El que tiene mis mandamientos y los guarda, ese es el que me ama; y el que me ama será amado por mi Padre; y yo lo amaré y me manifestaré a él.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-5',
        theme: 'La Palabra',
        ref: '2 Timoteo 3:16-17',
        text: {
            lbla: 'Toda Escritura es inspirada por Dios y útil para enseñar, para reprender, para corregir, para instruir en justicia, a fin de que el hombre de Dios sea perfecto, equipado para toda buena obra.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-6',
        theme: 'La Palabra',
        ref: 'Josue 1:8',
        text: {
            lbla: 'Este libro de la ley no se apartará de tu boca, sino que meditarás en él día y noche, para que cuides de hacer todo lo que en él está escrito; porque entonces harás prosperar tu camino y tendrás éxito.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-7',
        theme: 'La Oración',
        ref: 'Juan 15:7',
        text: {
            lbla: 'Si permanecéis en mí, y mis palabras permanecen en vosotros, pedid lo que queráis y os será hecho.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-8',
        theme: 'La Oración',
        ref: 'Filipenses 4:6-7',
        text: {
            lbla: 'Por nada estéis afanosos; antes bien, en todo, mediante oración y súplica con acción de gracias, sean dadas a conocer vuestras peticiones delante de Dios. Y la paz de Dios, que sobrepasa todo entendimiento, guardará vuestros corazones y vuestras mentes en Cristo Jesús.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-9',
        theme: 'La Comunión',
        ref: 'Mateo 18:20',
        text: {
            lbla: 'Porque donde están dos o tres reunidos en mi nombre, allí estoy yo en medio de ellos.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-10',
        theme: 'La Comunión',
        ref: 'Hebreos 10:24-25',
        text: {
            lbla: 'y consideremos cómo estimularnos unos a otros al amor y a las buenas obras, no dejando de congregarnos, como algunos tienen por costumbre, sino exhortándonos unos a otros, y mucho más al ver que el día se acerca.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-11',
        theme: 'Testificando',
        ref: 'Mateo 4:19',
        text: {
            lbla: 'Y les dijo: Seguidme, y yo os haré pescadores de hombres.'
        }
    },
    {
        groupClass: 'is-link',
        group: 'Vivir la Vida Nueva',
        number: 'A-12',
        theme: 'Testificando',
        ref: 'Romanos 1:16',
        text: {
            lbla: 'Porque no me avergüenzo del evangelio, pues es el poder de Dios para la salvación de todo el que cree; del judío primeramente y también del griego.'
        }
    }
];

export default Items;